import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { useAssetsUrlBuilder } from '@root/shared'
import { useTranslation } from '@root/shared/localization'

import type { Comment } from '@root/entities/comment'

type CommentItemBodyContentProps = {
  comment: Comment.Comment
}

export const CommentItemBodyContent = ({
  comment,
}: CommentItemBodyContentProps) => {
  const { t } = useTranslation()
  const { commentAttachmentUrl } = useAssetsUrlBuilder()

  const renderImage = () => {
    const attachment = comment.imageAttachment

    if (!attachment) {
      return undefined
    }

    const isExternal =
      attachment.startsWith('http') || attachment.startsWith('data:')
    const imageUrl = isExternal ? attachment : commentAttachmentUrl(attachment)

    return <AttachedImage src={imageUrl} alt={t('comment.image_attachment')} />
  }

  return (
    <Root>
      <Text>{comment.content}</Text>
      {renderImage()}
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 8px;
  width: 100%;
`

const Text = styled(Typography)`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`

const AttachedImage = styled.img`
  max-width: 500px;
`
